import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-diagnosed-only',
  templateUrl: './diagnosed-only.component.html',
  styleUrls: ['./diagnosed-only.component.css']
})
export class DiagnosedOnlyComponent implements OnInit {

  @Input() indicationDisplayName;

  constructor() { }

  ngOnInit() {
  }

}
